import { AxiosRequestConfig } from 'axios';

export interface ClientApiConfig extends AxiosRequestConfig {
    /**
     * Defaults to process env USERS_API_URL key.
     * Throws if not found.
     */
    baseURL?: string;

    /**
     * Turns on logging. True by default
     */
    debug?: boolean;

    /**
     * Namespace used for env reading if default config is chosen
     */
    namespace?: string;

    /**
     * Forward domain cookies
     */
    withCredentials?: boolean;
}
